import Route from "./Route";
import { useNavigate } from "react-router-dom";
import { RiDashboard3Fill, RiAuctionFill } from "react-icons/ri";
import { ImMenu } from "react-icons/im";
import { FaStore, FaUsers, FaUserPlus, FaClipboardList, FaGavel, FaChartLine } from "react-icons/fa";
import { MdAddBusiness, MdPerson } from "react-icons/md";
import { HiDocumentReport } from "react-icons/hi";
import { useSidebar } from "../contexts/SidebarContext";

export default function NavBar() {
  const navigate = useNavigate();
  const { isCollapsed, toggleSidebar } = useSidebar();

  return (
    <div className={`bg-gradient-to-b from-slate-900 via-slate-900 to-slate-950 h-full flex flex-col shadow-2xl transition-all duration-300 ${isCollapsed ? 'w-20' : 'w-full'}`}>
      {/* Header Section with Gradient */}
      <div className="relative p-6 mb-2">
        <div className="absolute inset-0 bg-gradient-to-r from-blue-600/10 via-blue-700/10 to-blue-600/10"></div>
        <div className={`relative flex items-center ${isCollapsed ? 'justify-center flex-col gap-3' : 'justify-between'}`}>
          <div className={`flex items-center gap-3 ${isCollapsed ? 'flex-col' : ''}`}>
            <div className="w-10 h-10 rounded-lg bg-gradient-to-br from-blue-500 to-blue-700 flex items-center justify-center shadow-lg shadow-blue-500/30">
              <RiAuctionFill className="text-white text-xl" />
            </div>
            {!isCollapsed && (
              <div>
                <div className="text-xl font-bold text-white tracking-wide">Auction</div>
                <div className="text-xs text-slate-400 font-medium">Management System</div>
              </div>
            )}
          </div>
          <ImMenu
            onClick={toggleSidebar}
            className="text-lg text-slate-400 hover:text-white cursor-pointer transition-all duration-300 hover:rotate-180"
          />
        </div>
      </div>

      {/* Navigation Section */}
      <div className={`flex-1 space-y-1 overflow-y-auto custom-scrollbar ${isCollapsed ? 'px-2' : 'px-3'}`}>
        {/* Dashboard Section */}
        <Route
          name="Dashboard"
          onClick={() => navigate("home")}
          icon={<RiDashboard3Fill />}
          urlPath="home"
          isCollapsed={isCollapsed}
        />

        {/* Divider */}
        {!isCollapsed && (
          <div className="py-2">
            <div className="h-px bg-gradient-to-r from-transparent via-slate-700 to-transparent"></div>
          </div>
        )}

        {/* Shop Management Section */}
        {!isCollapsed && (
          <div className="pt-2 pb-1 px-2">
            <div className="text-xs font-semibold text-slate-500 uppercase tracking-wider">Shop Management</div>
          </div>
        )}

        <Route
          name="Shop Registration"
          onClick={() => navigate("addNewShop")}
          icon={<MdAddBusiness />}
          urlPath="addNewShop"
          isCollapsed={isCollapsed}
        />

        <Route
          name="All Shops"
          onClick={() => navigate("shopList")}
          icon={<FaStore />}
          urlPath="shopList"
          isCollapsed={isCollapsed}
        />

        {/* Divider */}
        {!isCollapsed && (
          <div className="py-2">
            <div className="h-px bg-gradient-to-r from-transparent via-slate-700 to-transparent"></div>
          </div>
        )}

        {/* User Management Section */}
        {!isCollapsed && (
          <div className="pt-2 pb-1 px-2">
            <div className="text-xs font-semibold text-slate-500 uppercase tracking-wider">User Management</div>
          </div>
        )}

        <Route
          name="Add User"
          onClick={() => navigate("addNewUser")}
          icon={<FaUserPlus />}
          urlPath="addNewUser"
          isCollapsed={isCollapsed}
        />

        <Route
          name="All Users"
          onClick={() => navigate("userList")}
          icon={<FaUsers />}
          urlPath="userList"
          isCollapsed={isCollapsed}
        />

        <Route
          name="Rejected Users List"
          onClick={() => navigate("userRejectedList")}
          icon={<FaUsers />}
          urlPath="userRejectedList"
          isCollapsed={isCollapsed}
        />

        {/* Divider */}
        {!isCollapsed && (
          <div className="py-2">
            <div className="h-px bg-gradient-to-r from-transparent via-slate-700 to-transparent"></div>
          </div>
        )}

        {/* Auction Section */}
        {!isCollapsed && (
          <div className="pt-2 pb-1 px-2">
            <div className="text-xs font-semibold text-slate-500 uppercase tracking-wider">Auction Operations</div>
          </div>
        )}

        <Route
          name="Create Auction"
          onClick={() => navigate("auction")}
          icon={<FaGavel />}
          urlPath="auction"
          isCollapsed={isCollapsed}
        />

        <Route
          name="Live Auctions"
          onClick={() => navigate("currentAuction")}
          icon={<FaClipboardList />}
          urlPath="currentAuction"
          isCollapsed={isCollapsed}
        />

        <Route
          name="Auction Report"
          onClick={() => navigate("auctionReport")}
          icon={<HiDocumentReport />}
          urlPath="auctionReport"
          isCollapsed={isCollapsed}
        />

        {/* <Route
          name="Verify Demand Draft"
          onClick={() => navigate("verifyDemandDraft")}
          icon={<HiDocumentReport />}
          urlPath="verifyDemandDraft"
          isCollapsed={isCollapsed}
        /> */}

        {/* Divider */}
        {!isCollapsed && (
          <div className="py-2">
            <div className="h-px bg-gradient-to-r from-transparent via-slate-700 to-transparent"></div>
          </div>
        )}

        {/* Profile Section */}
        <Route
          name="Profile"
          onClick={() => navigate("profile")}
          icon={<MdPerson />}
          urlPath="profile"
          isCollapsed={isCollapsed}
        />

        {/* Bottom Spacing */}
        <div className="h-4"></div>
      </div>

      {/* Footer Section */}
      <div className="relative p-4 border-t border-slate-800/50">
        <div className="absolute inset-0 bg-gradient-to-t from-slate-950/50 to-transparent"></div>
        <div className="relative text-xs text-slate-500 text-center font-medium">
          <div className="flex items-center justify-center gap-2">
            <div className="w-1.5 h-1.5 rounded-full bg-green-500 animate-pulse"></div>
            {!isCollapsed && <span>v1.0.0</span>}
          </div>
        </div>
      </div>

      <style jsx>{`
        .custom-scrollbar::-webkit-scrollbar {
          width: 6px;
        }
        .custom-scrollbar::-webkit-scrollbar-track {
          background: transparent;
        }
        .custom-scrollbar::-webkit-scrollbar-thumb {
          background: #475569;
          border-radius: 3px;
        }
        .custom-scrollbar::-webkit-scrollbar-thumb:hover {
          background: #64748b;
        }
      `}</style>
    </div>
  );
}
